export default __webpack_public_path__ + "static/house-91889f0b258843c65ff404126aac33e8.gif";